import { render, staticRenderFns } from "./HomeMainBannerV3.vue?vue&type=template&id=265143e5"
import script from "./HomeMainBannerV3.vue?vue&type=script&lang=js"
export * from "./HomeMainBannerV3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports